module.exports = "/_next/static/pages/testing-environment/0bc76154c10512952ef235f95f14f097.png";